module.exports = __webpack_public_path__ + "img/22.d0ebb50e.png";